module.exports = __webpack_public_path__ + "img/presentation12.cb332c22.jpg";